import { CAPTELLO_QR_BASE_URL, ADDITIONAL_REGCODE_ATTRIBUTES } from '../constants/common'

export const generateCaptelloFromTemplateFields = (
  templateFields: string[],
  record?: Record<string, string>,
  registrationCode?: string
): string => {
  // Convert template fields like {FirstName} to a record of field names
  const fieldMap: Record<string, string> = {}

  templateFields.forEach((field) => {
    // Extract field name from template format {FieldName}
    const fieldMatch = field.match(/\{([^}]+)\}/)
    if (fieldMatch && fieldMatch[1]) {
      const fieldName = fieldMatch[1]
      // If record is provided, use the actual value from the record
      // Otherwise, keep the placeholder format
      fieldMap[fieldName] = record ? record[fieldName] || '' : `{${fieldName}}`
    }
  })

  // Add the registration code to the fieldMap if provided
  if (registrationCode) {
    fieldMap['RegistrationCode'] = registrationCode
  }

  // Add any additional registration-code attributes to the fieldMap
  if (record && ADDITIONAL_REGCODE_ATTRIBUTES?.length) {
    ADDITIONAL_REGCODE_ATTRIBUTES.forEach((attrName) => {
      if (!(attrName in fieldMap)) {
        fieldMap[attrName] = record[attrName] || ''
      }
    })
  }

  // Append any additional attributes to the registrationCode
  if (ADDITIONAL_REGCODE_ATTRIBUTES?.length) {
    const additionalAttributes = ADDITIONAL_REGCODE_ATTRIBUTES.map((attrName) =>
      (fieldMap[attrName] ?? '').trim()
    ).filter((value) => value !== '')

    if (additionalAttributes.length) {
      const existingRegistrationCode = fieldMap['RegistrationCode']?.trim() || ''
      fieldMap['RegistrationCode'] = existingRegistrationCode
        ? `${existingRegistrationCode},${additionalAttributes.join(',')}`
        : additionalAttributes.join(',')
    }
  }

  return constructCaptelloString(fieldMap)
}

function constructCaptelloString(fieldMap: Record<string, string>): string {
  // Start with the static URL
  const baseUrl = CAPTELLO_QR_BASE_URL

  // Define the fields to include in the order specified
  const fields = ['RegistrationId', 'EventId', 'RegistrationCode', 'FirstName', 'LastName', 'Company', 'JobTitle']

  const delimiter = '::'

  const EventId = localStorage.getItem('eventShortName') || 'EventCodeNotFound'

  fieldMap['EventId'] = EventId

  // Build the string by joining the fields with the delimiter
  const fieldValues = fields.map((field) => encodeURIComponent(fieldMap[field] || ''))

  let qrPayload = baseUrl + delimiter + fieldValues.join(delimiter)

  // remove the first delimiter from the final string
  if (qrPayload.length > 0) {
    qrPayload = qrPayload.replace('::', '')
  }

  return qrPayload
}
